const fetch = window.fetch;

/**
 * Latest evergreen browsers define these API's globally.
 * Add the constructors to `fetch` for a consistent cross-platform experience.
 * Technically client-side only code could directly use these API's. Code that
 * is used both client and server-side will benefit from consistency.
 */
fetch.Headers = window.Headers;
fetch.Request = window.Request;
fetch.Response = window.Response;
fetch.AbortController = window.AbortController;

module.exports = fetch;
